import { StripeOrderStatus } from "../../Stripe/StripeOrderDTO.ts";

export function OrderStatusRenderer({ status }: { status: StripeOrderStatus }) {
  switch (status) {
    case StripeOrderStatus.Pending:
      return (
        <span className={"bg-yellow-500 px-3 py-1 text-white rounded-md"}>
          In attesa
        </span>
      );
    case StripeOrderStatus.AwaitingConfirmation:
      return (
        <span className={"bg-blue-500 px-3 py-1 text-white rounded-md"}>
          In finalizzazione
        </span>
      );
    case StripeOrderStatus.Refunded:
      return (
        <span className={"bg-blue-500 px-3 py-1 text-white rounded-md"}>
          Rimborsato
        </span>
      );
    case StripeOrderStatus.PartiallyRefunded:
      return (
        <span className={"bg-blue-500 px-3 py-1 text-white rounded-md"}>
          Parzialmente Rimborsato
        </span>
      );
    case StripeOrderStatus.Succeeded:
      return (
        <span className={"bg-green-500 px-3 py-1 text-white rounded-md"}>
          Completato
        </span>
      );
    case StripeOrderStatus.InstallmentPaid:
      return (
        <span className={"bg-green-500 px-3 py-1 text-white rounded-md"}>
          Rata pagata
        </span>
      );
    case StripeOrderStatus.InstallmentDelinquent:
      return (
        <span className={"bg-yellow-500 px-3 py-1 text-white rounded-md"}>
          Delinquent
        </span>
      );
    case StripeOrderStatus.SubscriptionCancelled:
      return (
        <span className={"bg-red-500 px-3 py-1 text-white rounded-md"}>
          Subscription Canceled
        </span>
      );
    case StripeOrderStatus.Failed:
      return (
        <span className={"bg-red-500 px-3 py-1 text-white rounded-md"}>
          Pagamento Fallito
        </span>
      );
    case StripeOrderStatus.InstallmentsSettledByBankTransfer:
      return (
        <span className={"bg-teal-600 px-3 py-1 text-white rounded-md"}>
          Saldo rate
        </span>
      );
    default:
      return (
        <span className={"bg-gray-500 px-3 py-1 text-white rounded-md"}>
          Stato sconosciuto: {status}
        </span>
      );
  }
}
